import { Flex, FlexProps, Link } from 'rebass';
import React from 'react';
import { S3File } from './types';
import { getExtensionForType } from '@ecosconnect/core/src/helpers/mime-type';
import Icon from '../Icon/Icon';

type FilePreviewProps = {
  file: Pick<S3File, 'contentType' | 'thumb' | 'url'>;
  iframeProps?: Omit<JSX.IntrinsicElements['iframe'], 'src'>;
} & FlexProps;

const FilePreview: React.FC<FilePreviewProps> = (props) => {
  const { file, iframeProps, ...flexProps } = props;

  const extension = getExtensionForType(file.contentType);

  return (
    <Link
      {...(flexProps as any)}
      sx={{
        p: 0,
        bg: 'white',
        flexGrow: 1,
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        flexShrink: 1,
        backgroundImage:
          file.contentType.startsWith('image/') && file.thumb
            ? `url('${file.thumb}')`
            : undefined,
        backgroundColor:
          file.contentType.startsWith('image/') && file.thumb
            ? '#111'
            : undefined,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        borderRadius: 'defaultNested',
        color: 'primary',
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        cursor: 'pointer',
        overflow: 'hidden',
        wordBreak: 'break-all',
        textDecoration: 'none',
        // boxShadow: 'm',
        ':hover': {
          outlineStyle: 'solid',
          outlineColor: 'primary',
          outlineWidth: 3,
        },
        ...flexProps.sx,
      }}
      href={file.url}
      target="_blank"
    >
      {!file.contentType.startsWith('image/') && (
        <>
          {!file.contentType.endsWith('/pdf') && (
            <Flex flexDirection="row" sx={{ gap: 1 }} alignItems="center">
              {extension ? `${extension}` : 'File'}
              <Icon icon="file-download" />
            </Flex>
          )}
          {file.contentType.endsWith('/pdf') && (
            <iframe
              frameBorder={0}
              height="100%"
              width="100%"
              {...iframeProps}
              style={{
                padding: 0,
                border: 'none',
                pointerEvents: 'none',
                ...iframeProps?.style,
              }}
              src={file.url + '#view=FitV&toolbar=0'}
            />
          )}
        </>
      )}
    </Link>
  );
};

export default FilePreview;
